import { z } from 'zod';
import { ItemDefSchema } from './item.schema.js';
import { QuestDTOSchema } from './quest.schema.js';
export const PendingLootItemSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('equipment'),
        itemId: z.string(),
        quantity: z.number().int().min(1),
        def: ItemDefSchema,
    }),
    z.object({
        type: z.literal('gold'),
        quantity: z.number().int().min(1),
    }),
    z.object({
        type: z.literal('food'),
        quantity: z.number().int().min(1),
    }),
    // An existing ItemInstance transferred to the player on claim (e.g. an item a
    // defeated NPC held, or a quest reward). Claiming moves it rather than creating one.
    z.object({
        type: z.literal('instance'),
        instanceId: z.string(),
        defId: z.string(),
        quantity: z.literal(1),
        def: ItemDefSchema,
    }),
]);
export const PendingLootSchema = z.object({
    tableId: z.string(),
    items: z.array(PendingLootItemSchema),
});
export const LootClaimRequestSchema = z.object({
    gameId: z.string(),
});
export const LootClaimResponseSchema = z.object({
    inventory: z.array(z.any()),
    skipped: z.number().int().min(0),
    gold: z.number().int().min(0),
    food: z.number().int().min(0),
    pendingLoot: PendingLootSchema.optional(),
    // Fetch quests whose possession requirement was satisfied by this claim and so
    // were promoted to ready_to_complete. Lets the client update the journal + notify.
    promotedQuests: z.array(QuestDTOSchema).optional(),
});
export const LootDismissRequestSchema = z.object({
    gameId: z.string(),
});
export const ClaimItemRequestSchema = z.object({
    gameId: z.string(),
    index: z.number().int().min(0),
});
